export default {
  'costCenters.domain.code': 'Código',
  'costCenters.domain.description': 'Descrição',
  'costCenters.domain.updatedAt': 'Modificado em',
  'costCenters.generateReport': 'Gerar Relatório',
  'costCenters.create': 'Criar Novo Centro de custo',
  'costCenters.modal.report.title': 'Gerar Relatório',
  'costCenters.modal.report.buttons.pdf': 'Gerar PDF',
  'costCenters.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'costCenters.modal.report.buttons.rtf': 'Gerar RTF',
  'costCenters.modal.report.form.description': 'Descrição',
  'costCenters.modal.general.new.title': 'Novo Centro de custo',
  'costCenters.modal.general.edit.title': 'Editar Centro de custo',
  'costCenters.modal.general.form.description': 'Descrição',

  'costCenters.create.notification.success': 'Sucesso!',
  'costCenters.create.notification.successDescription':
    'Centro de custo criado com sucesso!',
  'costCenters.update.notification.success': 'Sucesso!',
  'costCenters.update.notification.successDescription':
    'Centro de custo atualizado com sucesso!',
  'costCenters.contacts.remove.modal.title': 'Remover centro de custo',
  'costCenters.contacts.remove.modal.content':
    'Deseja realmente remover o centro de custo?',
  'costCenters.contacts.remove.notification.success': 'Sucesso!',
  'costCenters.contacts.remove.notification.successDescription':
    'O centro de custo foi removido com sucesso!',
  'costCenters.contacts.remove.modal.okText': 'Remover',
  'costCenters.update.status.message.success':
    'Status de Centro de Custo alterado com sucesso!',
};
